import React from 'react';
import styled from 'styled-components';

import CoverNav from './cover-nav';
import ListNav from './list-nav';
import { useNav } from './provider';

const Nav = ({
  className,
  listNav,
  navBreakpoint,
  ...props
}) => {
  const { open } = useNav();
  const NavComponent = open ? CoverNav : ListNav;

  return (
    <NavComponent
      className={className}
      navBreakpoint={navBreakpoint || '62rem'}
      {...props}
    />
  );
};

export default styled(Nav)``;
